import { useState } from "react";
import { Link } from "react-router-dom";
import { X, Check } from "lucide-react";

const STEPS = [
  ["Create your first delivery", "Add pickup and dropoff addresses and we handle the rest.", "/merchant/create"],
  ["Get matched to a verified driver", "Every driver is licence, insurance and background checked.", "/merchant/orders"],
  ["Track it live from your dashboard", "Follow status changes and get a receipt when it lands.", "/merchant/orders"],
];

export const OnboardingChecklist = ({ userId, orderCount }) => {
  const key = `routa_onboarding_dismissed_${userId}`;
  const [hidden, setHidden] = useState(() => localStorage.getItem(key) === "1");
  if (hidden) return null;
  const done = [orderCount > 0, orderCount > 0, orderCount > 0];
  const dismiss = () => { localStorage.setItem(key, "1"); setHidden(true); };

  return (
    <div className="border border-[#0a0a0a] mb-10" data-testid="onboarding-checklist">
      <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
        <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">[00] Getting started</span>
        <button onClick={dismiss} className="text-gray-400 hover:text-[#0a0a0a] transition-colors" aria-label="Dismiss" data-testid="onboarding-dismiss-button">
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
        {STEPS.map(([title, desc, to], i) => (
          <Link key={title} to={to} className="px-5 py-5 hover:bg-gray-50 transition-colors group" data-testid={`onboarding-step-${i + 1}`}>
            <div className="flex items-center gap-3">
              <span className={`h-6 w-6 flex items-center justify-center font-mono text-[11px] ${done[i] ? "bg-[#0a0a0a] text-white" : "border border-gray-300 text-gray-500"}`}>
                {done[i] ? <Check className="h-3.5 w-3.5" /> : `0${i + 1}`}
              </span>
              <span className={`text-sm font-semibold ${done[i] ? "text-gray-400 line-through" : "text-[#0a0a0a]"}`}>{title}</span>
            </div>
            <p className="mt-2 text-xs text-gray-500 leading-relaxed">{desc}</p>
            <span className="mt-3 inline-block font-mono text-[11px] tracking-[0.14em] uppercase text-orange-600 opacity-0 group-hover:opacity-100 transition-opacity">Go →</span>
          </Link>
        ))}
      </div>
    </div>
  );
};
